import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { Chip, Input, OnboardingContainer, spacing } from '@pletly/ui';
import AddIcon from '%assets/icons/plus.svg';
import { useInviteToConnect } from './useInviteToConnect';

interface Props {
	title: string;
	subtitle: string;
	userUuid: string;
	disableSkip?: boolean;
	disableGoBack?: boolean;
	onSuccess: () => void;
}

export const InviteToConnect = ({
	title,
	subtitle,
	userUuid,
	disableSkip,
	disableGoBack = true,
	onSuccess,
}: Props) => {
	const { t } = useTranslation();
	const {
		handleAddEmail,
		handleRemoveEmail,
		handleSendPress,
		emailInput,
		emails,
		goToHome,
		goBack,
	} = useInviteToConnect({ userUuid, onSuccess });

	return (
		<OnboardingContainer
			title={title}
			subtitle={subtitle}
			ctaText={t('connections.send-invitations')}
			onNextClick={handleSendPress}
			isNextDisabled={!emails.length}
			onSkipClick={disableSkip ? undefined : goToHome}
			itemsAlignment="center"
			{...(!disableGoBack && {
				onSecondaryClick: goBack,
				secondaryButtonText: t('common.back'),
			})}
		>
			<View style={styles.inputRow}>
				<Input
					textContentType="emailAddress"
					placeholder={t('common.e-mail')}
					autoCorrect={false}
					blurOnSubmit={false}
					onSubmitEditing={handleAddEmail}
					style={styles.emailInput}
					{...emailInput}
				/>
				<TouchableOpacity onPress={handleAddEmail}>
					<AddIcon />
				</TouchableOpacity>
			</View>
			<View style={styles.chipsContainer}>
				{emails.map((email) => (
					<Chip key={email} text={email} onDeletePress={handleRemoveEmail(email)} />
				))}
			</View>
		</OnboardingContainer>
	);
};

const styles = StyleSheet.create({
	inputRow: {
		flexDirection: 'row',
		alignItems: 'center',
		width: '100%',
	},
	emailInput: {
		flex: 1,
		marginEnd: spacing(2),
	},
	chipsContainer: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginVertical: spacing(2),
	},
});
